<template>
  <div class="header-container">
    <a href="https://forensic-architecture.org" class="logoc">
      <img src="../assets/logo.png" />
    </a>
    <h1 class="center" v-html="md(title)" />
    <v-flex class="warning-container">{{ warningMsg }}</v-flex>
    <v-flex>
    </v-flex>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: 'LayoutIntro',
  props: {
    lang: String,
    title: String,
    warningMsg: String
  },
  methods: {
    md: function (content) {
      return marked(content)
    },
    toggleLang: function () {
      this.$store.commit('toggleLang')
    },
    showMore: function () {
      this.moreShowing = true
    }
  }
}
</script>

<style>
@media only screen and (max-width: 800px) {
    .header-img {
        width: 100%;
    }
}
.fullw {
  width: 100%;
  height: 56.25vw;
}
.logoc {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1em;
}
.logoc img {
  width: 200px;
  max-width: 80vw;
}
.header-container {
  margin: 0;
  margin-bottom: 1em;
  padding: 0;
  width: 100vw;
  max-width: 100vw;
}
.center {
  text-align: center;
}
.warning-container {
  text-align: center;
  /* padding-right: 2em; */
  margin-bottom: 3px;
  color: rgb(135, 0, 0);
  border-radius: 1px;
  max-width: 600px;
}
.header-img {
  max-width: 752px;
}
</style>
